import { apiRequest } from '@services/apiClient';
import authEndpoints from '@services/auth/authEndpoints';

export function registerRequest(payload) {
  return apiRequest(authEndpoints.register, {
    method: 'POST',
    body: payload
  });
}

export function loginRequest(payload) {
  return apiRequest(authEndpoints.login, {
    method: 'POST',
    body: payload
  });
}

export function verifyLoginCodeRequest(payload) {
  return apiRequest(authEndpoints.verifyLoginCode, {
    method: 'POST',
    body: payload
  });
}

export function forgotPasswordRequest(payload) {
  return apiRequest(authEndpoints.forgotPassword, {
    method: 'POST',
    body: payload
  });
}

export function resetPasswordRequest(payload) {
  return apiRequest(authEndpoints.resetPassword, {
    method: 'POST',
    body: payload
  });
}

export function getProfileRequest() {
  return apiRequest(authEndpoints.session);
}

export function logoutRequest() {
  return apiRequest(authEndpoints.logout, {
    method: 'POST'
  });
}
